import { useEffect } from "react";

const APP_NAME = "Floorbit";

export function usePageTitle(title?: string | null) {
  useEffect(() => {
    const previousTitle = document.title;

    document.title = title ? `${title} | ${APP_NAME}` : APP_NAME;

    return () => {
      document.title = previousTitle;
    };
  }, [title]);
}
